import {
  InvestorFormFields,
  useInvestorEditForm,
} from "features/investors/InvestorEditForm";
import { InvestorReadData } from "gen/model/investorReadData";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormDrawer } from "shared/components/form/FormDrawer";

export interface InvestorFormDrawerProps {
  investor: InvestorReadData;
  onCloseComplete: () => void;
}

export const InvestorEditDrawer: React.FC<InvestorFormDrawerProps> = ({
  investor,
  onCloseComplete,
}) => {
  const { t } = useTranslation(["investor", "common"]);

  const formProps = useInvestorEditForm({ investor });

  return (
    <FormDrawer
      title={t("investor:edit.title")}
      formProps={formProps}
      bodyProps={{
        "data-private": true,
      }}
      onCloseComplete={onCloseComplete}
    >
      <InvestorFormFields />
    </FormDrawer>
  );
};
